import { fetchData } from 'api/services/mediaPlanning/utils';
import { ApiResponse } from 'api/services/mediaPlanning/types';
import { CAMPAIGNv3 } from './mediaPlanning';
import { CountryFormState } from '../../../store/planStore';
import { StatusInfo } from '../../../pages/calculator/MediaPlanning/MediaPlansTable/interfaces';

export interface PlanResponseData {
  campaignName: string;
  campaignCode: string;
  division: string;
  brand: string;
  category: string;
  id: string;
  countrySetup: Record<string, CountryFormState>;
  statusInfo: StatusInfo;
  isLocked?: boolean;
}
export const getPlanById = async (id: string) => {
  return fetchData<ApiResponse<PlanResponseData>>(
    `/${CAMPAIGNv3}/media-plans/${id}`
  );
};
